import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from 'core/models/user';
import { HttpDataService } from './http-data.service';
import { JobsService } from './jobs.service';

@Injectable()
export class UsersService extends HttpDataService {
  constructor(protected injector: Injector, protected jobsService: JobsService) {
    super(injector, '/core/users');
  }

  createUsers(clientId: string, data: any) {
    const url = `${this.baseUrl}/${clientId}`;
    return super.postRequest(url, JSON.stringify(data), this.getRequestOptions());
  }

  importCsvUsers(clientId: string, data: any) {
    const url: string = `${this.baseUrl}/${clientId}/batch`;
    const formData: FormData = new FormData();
    formData.append('file', data);

    return super.postRequest(url, formData, {});
  }

  changeEmailUsers(clientId: string, data: any) {
    const url: string = `${this.baseUrl}/${clientId}/batch/email`;
    const formData: FormData = new FormData();
    formData.append('file', data);

    return super.putRequest(url, formData, {});
  }

  getUser(id: string): Observable<User> {
    return super.getItem(id);
  }

  changeRole(user: User, data: any) {
    const url = `${this.baseUrl}/${user.id}/role`;
    return super.putRequest(url, JSON.stringify(data), this.getRequestOptions());
  }

  updateEmail(userId: string, newEmail: string, confirmed?: boolean) {
    let url = `${this.baseUrl}/${userId}/email`;
    if (confirmed) {
      url += '?emailUpdateConfirmed=true';
    }
    return super.putRequest(url, { email: newEmail }, this.getRequestOptions());
  }
}
